import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-full-5" }
const _hoisted_2 = {
  key: 0,
  class: "flex-center py-10"
}
const _hoisted_3 = {
  key: 1,
  class: "alert alert-danger mb-4"
}
const _hoisted_4 = { class: "s20" }
const _hoisted_5 = { class: "mb-5" }
const _hoisted_6 = { class: "s20 widget pb-2" }
const _hoisted_7 = { class: "container-full-2 s20 my-5" }
const _hoisted_8 = { class: "s13 flex justify-content-right" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "form-field-floating default sm s6_mobile ml-3" }
const _hoisted_13 = { class: "grid-filter6 mt-4 mb-0" }
const _hoisted_14 = { class: "form-field-floating reactive sm" }
const _hoisted_15 = { class: "form-field-floating reactive sm" }
const _hoisted_16 = { class: "form-field-floating sm" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { class: "table separator skin3 rounded selection" }
const _hoisted_20 = {
  class: "btn-circle",
  for: "check-all"
}
const _hoisted_21 = { class: "flex-right" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { key: 0 }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["for"]
const _hoisted_27 = ["id", "value"]
const _hoisted_28 = { class: "flex" }
const _hoisted_29 = {
  class: "square-xl rounded-15",
  style: {"background-color":"rgb(var(--color-warning-rgb), 0.2)"}
}
const _hoisted_30 = ["src"]
const _hoisted_31 = { class: "mb-1 font-semibold" }
const _hoisted_32 = { class: "text-sm text-grey-500" }
const _hoisted_33 = { class: "mb-2 color-info" }
const _hoisted_34 = { class: "text-sm text-grey-500" }
const _hoisted_35 = { class: "text-sm text-grey-500" }
const _hoisted_36 = { class: "flex-right" }
const _hoisted_37 = ["disabled", "onClick"]
const _hoisted_38 = ["disabled", "onClick"]
const _hoisted_39 = ["disabled", "onClick"]
const _hoisted_40 = ["disabled", "onClick"]
const _hoisted_41 = ["onClick", "disabled"]
const _hoisted_42 = ["onClick"]
const _hoisted_43 = {
  key: 0,
  class: "bg-white"
}
const _hoisted_44 = {
  colspan: "7",
  class: "collapse-content-table"
}
const _hoisted_45 = { class: "grid6 grid-row-gap-1 px-10 pb-4" }
const _hoisted_46 = {
  key: 0,
  class: "flex text-grey-600"
}
const _hoisted_47 = { class: "pagination sm justify-content-right mb-0" }
const _hoisted_48 = ["disabled"]
const _hoisted_49 = ["onClick"]
const _hoisted_50 = ["disabled"]

import { ref, reactive, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import membersService from '@/services/membersService'
import authService from '@/services/authService'
import { showAlert, showConfirm, showToast } from '@/utils/swal'
import ImportMembresComponent from '@/components/ImportMembresComponent.vue'

interface Member {
  id: number
  nom: string
  prenom: string
  collectivite?: {
    id: number
    nom: string
  }
  photo?: string
  photo_url?: string
  email?: string
  telephone?: string
  created_at: string
  actif: number
  deleted_at?: string | null
  fonction?: string
  permissions?: string[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CollectivitesMembres',
  setup(__props) {

const router = useRouter()

const showFilters = ref(false)
const selectedItems = ref<number[]>([])
const selectAll = ref(false)
const expandedRows = ref<number[]>([])
const currentPage = ref(1)
const perPage = ref(10)
const loading = ref(false)
const loadingInvitations = ref(false)
const errorMessage = ref('')
const refreshKey = ref(0)
const startupInfos = reactive({
  collectivites: [] as any[],
  pays: [] as any[]
})

const filters = reactive({
  sort: '',
  dateFrom: '',
  dateTo: '',
  etat: ''
})

// Données réelles depuis l'API
const members = ref<Member[]>([])
const pagination = reactive({
  total: 0,
  per_page: 10,
  last_page: 1
})

onMounted(async () => {
  await loadStartupInfos()
  await loadMembers()
})

async function loadStartupInfos() {
  try {
    const data = await membersService.getStartupInfos()
    startupInfos.collectivites = data.collectivites || []
    startupInfos.pays = data.pays || []
  } catch (error: any) {
    console.error('Erreur lors du chargement des données de démarrage:', error)
  }
}

async function loadMembers() {
  try {
    loading.value = true
    errorMessage.value = ''
    
    // Récupérer la collectivité de l'utilisateur connecté
    let currentUser = authService.getCurrentUser()
    
    // Si les données utilisateur ne contiennent pas la collectivité, récupérer le profil complet
    if (currentUser && !currentUser.collectivite_id && !currentUser.collectivite?.id && !(currentUser as any).collectiviteId) {
      try {
        const profileResponse = await authService.getProfile()
        if (profileResponse.status === 0 && profileResponse.data) {
          currentUser = profileResponse.data
          // Mettre à jour les données utilisateur dans le stockage
          const TokenStorage = (await import('@/services/apiConfig')).TokenStorage
          TokenStorage.setUser(currentUser)
        }
      } catch (profileError) {
        console.error('Erreur lors de la récupération du profil:', profileError)
      }
    }
    
    const userCollectiviteId = currentUser?.collectivite_id || (currentUser as any)?.collectiviteId || currentUser?.collectivite?.id || null
    
    if (!userCollectiviteId) {
      errorMessage.value = 'Aucune collectivité associée à votre compte'
      members.value = []
      return
    }
    
    // Gestion du tri
    let sortColumn = 'fullname'
    let sortDir = 'ASC'
    let sortOption = 'fullname_asc'
    
    if (filters.sort) {
      sortOption = filters.sort
      if (filters.sort === 'fullname_asc') {
        sortColumn = 'fullname'
        sortDir = 'ASC'
      } else if (filters.sort === 'fullname_desc') {
        sortColumn = 'fullname'
        sortDir = 'DESC'
      } else if (filters.sort === 'created_at_asc') {
        sortColumn = 'created_at'
        sortDir = 'ASC'
      } else if (filters.sort === 'created_at_desc') {
        sortColumn = 'created_at'
        sortDir = 'DESC'
      }
    }
    
    const queryParams: any = {
      pageNumber: currentPage.value,
      pageSize: perPage.value, // L'API backoffice utilise pageSize, pas per_page
      sortColumn,
      sortDir,
      sortOption,
      collectivite_id: String(userCollectiviteId) // Filtrer par collectivité
    }
    
    // Filtres de date
    if (filters.dateFrom) {
      queryParams.borneInf = filters.dateFrom
    }
    if (filters.dateTo) {
      queryParams.borneSup = filters.dateTo
    }
    
    // Filtre d'état (trashed: 0 = actifs, 1 = supprimés/inactifs)
    if (filters.etat === 'inactif') {
      queryParams.trashed = 1
    } else if (filters.etat === 'actif') {
      queryParams.trashed = 0
    }
    
    const response = await membersService.listMembers(queryParams)
    
    // LengthAwarePaginator retourne directement les propriétés dans response
    members.value = response.data || []
    pagination.total = response.total || 0
    pagination.per_page = response.per_page || 10
    pagination.last_page = response.last_page || 1
  } catch (error: any) {
    console.error('Erreur lors du chargement des membres:', error)
    errorMessage.value = error.message || 'Erreur lors du chargement des membres'
    members.value = []
  } finally {
    loading.value = false
  }
}

const totalPages = computed(() => pagination.last_page || Math.ceil(members.value.length / perPage.value))

const visiblePages = computed(() => {
  const pages: number[] = []
  const maxVisible = 3
  let start = Math.max(1, currentPage.value - Math.floor(maxVisible / 2))
  let end = Math.min(totalPages.value, start + maxVisible - 1)
  
  if (end - start < maxVisible - 1) {
    start = Math.max(1, end - maxVisible + 1)
  }
  
  for (let i = start; i <= end; i++) {
    pages.push(i)
  }
  
  return pages.length > 0 ? pages : [1]
})

function toggleFilters() {
  showFilters.value = !showFilters.value
}

function onFiltersChanged() {
  currentPage.value = 1
  loadMembers()
}

function handleSelectAll() {
  if (selectAll.value) {
    selectedItems.value = members.value.map(m => m.id)
  } else {
    selectedItems.value = []
  }
}

function toggleRowDetails(index: number) {
  const member = members.value[index]
  if (member) {
    router.push({ name: 'collectivites-membre-detail', params: { id: member.id } })
  }
}

function goToMemberDetail(memberId: number) {
  router.push({ name: 'collectivites-membre-detail', params: { id: memberId } })
}

function goToMemberEdit(memberId: number) {
  router.push({ name: 'collectivites-membre-edit', params: { id: memberId } })
}

function getCardColor(status: string): string {
  const colors: Record<string, string> = {
    actif: 'rgb(var(--color-info-rgb), 0.2)',
    inactif: 'rgb(var(--color-warning-rgb), 0.2)',
    suspendu: 'rgb(var(--color-danger-rgb), 0.2)'
  }
  return colors[status] || 'rgb(var(--color-info-rgb), 0.2)'
}

function formatDate(dateString: string): string {
  if (!dateString) return ''
  // Si la date est déjà formatée, la retourner telle quelle
  if (dateString.includes('Nov') || dateString.includes('Dec') || dateString.includes('Jan')) {
    return dateString
  }
  // Sinon, formater la date
  try {
    const date = new Date(dateString)
    if (isNaN(date.getTime())) return dateString
    return date.toLocaleDateString('fr-FR', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })
  } catch {
    return dateString
  }
}

function goToPage(page: number) {
  if (page >= 1 && page <= totalPages.value) {
    currentPage.value = page
    loadMembers()
  }
}

async function handleExportExcel() {
  try {
    loading.value = true
    errorMessage.value = ''
    
    const queryParams: any = {}
    if (filters.dateFrom) queryParams.borneInf = filters.dateFrom
    if (filters.dateTo) queryParams.borneSup = filters.dateTo
    if (filters.etat) queryParams.trashed = filters.etat === 'inactif' ? 1 : 0
    
    const blob = await membersService.exportToExcel(queryParams)
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', 'membres.xlsx')
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(url)
  } catch (error: any) {
    errorMessage.value = error.message || 'Erreur lors de l\'export Excel'
  } finally {
    loading.value = false
  }
}

async function handleExportPdf() {
  try {
    loading.value = true
    errorMessage.value = ''
    
    const queryParams: any = {}
    if (filters.dateFrom) queryParams.borneInf = filters.dateFrom
    if (filters.dateTo) queryParams.borneSup = filters.dateTo
    if (filters.etat) queryParams.trashed = filters.etat === 'inactif' ? 1 : 0
    
    const blob = await membersService.exportToPdf(queryParams)
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', 'membres.pdf')
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(url)
  } catch (error: any) {
    errorMessage.value = error.message || 'Erreur lors de l\'export PDF'
  } finally {
    loading.value = false
  }
}

async function doDeleteItem(member: Member) {
  const confirmation = await showConfirm(
    `Voulez-vous vraiment supprimer le membre ${member.nom} ${member.prenom} ?`,
    'Confirmation de suppression'
  )
  if (!confirmation) return

  try {
    loading.value = true
    errorMessage.value = ''
    await membersService.deleteMember(member.id)
    await showAlert.success('Membre supprimé avec succès.', 'Suppression réussie')
    await loadMembers() // Recharger la liste
  } catch (error: any) {
    errorMessage.value = error.message || 'Erreur lors de la suppression du membre.'
    await showAlert.error(errorMessage.value, 'Erreur de suppression')
  } finally {
    loading.value = false
  }
}

async function doRestoreItem(member: Member) {
  const confirmation = await showConfirm(
    `Voulez-vous vraiment restaurer le membre ${member.nom} ${member.prenom} ?`,
    'Confirmation de restauration'
  )
  if (!confirmation) return

  try {
    loading.value = true
    errorMessage.value = ''
    await membersService.restoreMember(member.id)
    await showAlert.success('Membre restauré avec succès.', 'Restauration réussie')
    await loadMembers() // Recharger la liste
  } catch (error: any) {
    errorMessage.value = error.message || 'Erreur lors de la restauration du membre.'
    await showAlert.error(errorMessage.value, 'Erreur de restauration')
  } finally {
    loading.value = false
  }
}

async function doToggleEtatValideAction(ids: number[]) {
  const confirmation = await showConfirm(
    `Voulez-vous vraiment modifier l'état des membres sélectionnés ?`,
    'Confirmation de modification'
  )
  if (!confirmation) return

  try {
    loading.value = true
    errorMessage.value = ''
    await membersService.toggleEtatValide(ids)
    await showAlert.success('État des membres mis à jour avec succès.', 'Mise à jour réussie')
    selectedItems.value = [] // Réinitialiser la sélection
    await loadMembers() // Recharger la liste
  } catch (error: any) {
    errorMessage.value = error.message || 'Erreur lors de la modification de l\'état des membres.'
    await showAlert.error(errorMessage.value, 'Erreur de mise à jour')
  } finally {
    loading.value = false
  }
}

async function doDeleteSelectedItems() {
  if (selectedItems.value.length === 0) {
    await showAlert.warning('Veuillez sélectionner au moins un membre à supprimer.', 'Aucune sélection')
    return
  }

  const confirmation = await showConfirm(
    `Voulez-vous vraiment supprimer les ${selectedItems.value.length} membre(s) sélectionné(s) ?`,
    'Confirmation de suppression multiple'
  )
  if (!confirmation) return

  try {
    loading.value = true
    errorMessage.value = ''
    // Supprimer chaque membre sélectionné
    for (const id of selectedItems.value) {
      await membersService.deleteMember(id)
    }
    await showAlert.success(`${selectedItems.value.length} membre(s) supprimé(s) avec succès.`, 'Suppression multiple réussie')
    selectedItems.value = [] // Réinitialiser la sélection
    await loadMembers() // Recharger la liste
  } catch (error: any) {
    errorMessage.value = error.message || 'Erreur lors de la suppression multiple des membres.'
    await showAlert.error(errorMessage.value, 'Erreur de suppression multiple')
  } finally {
    loading.value = false
  }
}

async function doToggleEtatValideSelectedItems() {
  if (selectedItems.value.length === 0) {
    await showAlert.warning('Veuillez sélectionner au moins un membre pour modifier son état.', 'Aucune sélection')
    return
  }
  await doToggleEtatValideAction(selectedItems.value)
}

async function downloadCsv() {
  try {
    const blob = await membersService.downloadCsvTemplate()
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement("a")
    link.href = url
    link.setAttribute("download", "collectivite_membres_template.csv")
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(url)
    showToast.success('Modèle CSV téléchargé avec succès')
  } catch (error: any) {
    console.error("Erreur de téléchargement :", error)
    showToast.error('Erreur lors du téléchargement du modèle CSV')
  }
}

function onMembersImported() {
  refreshKey.value++
  loadMembers()
}

async function sendInvitationsUnverified() {
  try {
    // Récupérer le nombre de membres non vérifiés
    const countResponse = await membersService.countUnverifiedMembers()
    const unverifiedCount = countResponse.count || 0
    
    if (unverifiedCount === 0) {
      showToast.info("Aucun membre non vérifié trouvé pour cette collectivité")
      return
    }
    
    // Afficher la confirmation
    const confirmation = await showConfirm(
      `Vous êtes sur le point d'envoyer ${unverifiedCount} invitation(s) aux membres non vérifiés de cette collectivité. Voulez-vous continuer ?`,
      "Envoyer les invitations"
    )
    
    if (!confirmation) {
      return
    }
    
    loadingInvitations.value = true
    
    const response = await membersService.sendInvitationsUnverified()
    
    showToast.success(response.message || 'Invitations envoyées avec succès')
    
    // Rafraîchir la liste après l'envoi
    setTimeout(() => {
      loadMembers()
    }, 1000)
  } catch (error: any) {
    console.error("Erreur lors de l'envoi des invitations:", error)
    showToast.error(error.message || "Une erreur est survenue lors de l'envoi des invitations")
  } finally {
    loadingInvitations.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[50] || (_cache[50] = _createElementVNode("h2", { class: "secondary-font gap-4 mt-2 mb-6" }, "Membres - Liste des membres", -1)),
    _cache[51] || (_cache[51] = _createElementVNode("div", { class: "clear-both h-0" }, null, -1)),
    (loading.value && members.value.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[9] || (_cache[9] = [
          _createElementVNode("div", { class: "loader dark" }, null, -1)
        ]))]))
      : _createCommentVNode("", true),
    (errorMessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(errorMessage.value), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(), _createBlock(ImportMembresComponent, {
          key: refreshKey.value,
          onCompleted: onMembersImported
        }))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _cache[21] || (_cache[21] = _createElementVNode("div", { class: "s7" }, [
            _createElementVNode("h4", { class: "font-semibold mt-4" }, [
              _createTextVNode("Utilisateurs "),
              _createElementVNode("span", { class: "text-sm text-grey-500" }, "(recent)")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              type: "button",
              onClick: downloadCsv,
              class: "btn normal ml-3 justify-content-center btn-filtre"
            }, [...(_cache[10] || (_cache[10] = [
              _createElementVNode("img", {
                src: "/public/icons/icon-telecharger.svg",
                class: "btn-icon",
                alt: ""
              }, null, -1),
              _createElementVNode("span", null, "Modèle CSV", -1)
            ]))]),
            _cache[14] || (_cache[14] = _createElementVNode("label", {
              for: "file-upload-membres-frontoffice",
              class: "btn normal ml-3 justify-content-center btn-filtre",
              style: {"cursor":"pointer"}
            }, [
              _createElementVNode("img", {
                src: "/public/icons/icon-upload.svg",
                class: "btn-icon",
                alt: ""
              }),
              _createElementVNode("span", null, "Importer CSV")
            ], -1)),
            _createElementVNode("button", {
              type: "button",
              onClick: sendInvitationsUnverified,
              class: "btn normal ml-3 justify-content-center btn-filtre",
              disabled: loadingInvitations.value
            }, [
              _cache[11] || (_cache[11] = _createElementVNode("img", {
                src: "/public/icons/icon-send.svg",
                class: "btn-icon",
                alt: ""
              }, null, -1)),
              (!loadingInvitations.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Envoyer invitations"))
                : (_openBlock(), _createElementBlock("span", _hoisted_11, "Envoi..."))
            ], 8, _hoisted_9),
            _createElementVNode("div", _hoisted_12, [
              _withDirectives(_createElementVNode("select", {
                class: "form-input-select",
                name: "sort",
                id: "sort",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.sort) = $event)),
                onChange: onFiltersChanged
              }, [...(_cache[12] || (_cache[12] = [
                _createStaticVNode("<option value=\"\">Trier</option><option value=\"fullname_asc\">Nom &amp; Prénoms (ASC)</option><option value=\"fullname_desc\">Nom &amp; Prénoms (DESC)</option><option value=\"created_at_asc\">Date (ASC)</option><option value=\"created_at_desc\">Date (DESC)</option>", 5)
              ]))], 544), [
                [_vModelSelect, filters.sort]
              ])
            ]),
            _createElementVNode("button", {
              class: _normalizeClass(["btn normal white2 s4_mobile ml-4 justify-content-center btn-filtre btn-filter", { active: showFilters.value }]),
              onClick: toggleFilters
            }, [...(_cache[13] || (_cache[13] = [
              _createElementVNode("img", {
                src: "/public/icons/icon-filter.svg",
                class: "btn-icon",
                alt: ""
              }, null, -1),
              _createElementVNode("span", null, "Options", -1)
            ]))], 2)
          ]),
          _cache[22] || (_cache[22] = _createElementVNode("div", { class: "clear-both" }, null, -1)),
          _createElementVNode("div", {
            class: _normalizeClass(["filter-set-area", { active: showFilters.value }])
          }, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  class: "form-input",
                  name: "date1",
                  id: "date1",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.dateFrom) = $event)),
                  onChange: onFiltersChanged,
                  placeholder: ""
                }, null, 544), [
                  [_vModelText, filters.dateFrom]
                ]),
                _cache[15] || (_cache[15] = _createElementVNode("label", { for: "date1" }, "Date de création <=", -1))
              ]),
              _createElementVNode("div", _hoisted_15, [
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  class: "form-input",
                  name: "date2",
                  id: "date2",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.dateTo) = $event)),
                  onChange: onFiltersChanged,
                  placeholder: ""
                }, null, 544), [
                  [_vModelText, filters.dateTo]
                ]),
                _cache[16] || (_cache[16] = _createElementVNode("label", { for: "date2" }, "Date de création >=", -1))
              ]),
              _createElementVNode("div", _hoisted_16, [
                _withDirectives(_createElementVNode("select", {
                  class: "form-input-select",
                  name: "etat",
                  id: "etat",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.etat) = $event)),
                  onChange: onFiltersChanged
                }, [...(_cache[17] || (_cache[17] = [
                  _createElementVNode("option", {
                    value: "",
                    selected: ""
                  }, "Tout les etats", -1),
                  _createElementVNode("option", { value: "actif" }, "Actif", -1),
                  _createElementVNode("option", { value: "inactif" }, "Inactif", -1)
                ]))], 544), [
                  [_vModelSelect, filters.etat]
                ]),
                _cache[18] || (_cache[18] = _createElementVNode("label", { for: "etat" }, [
                  _createTextVNode("Etat "),
                  _createElementVNode("b", { class: "color-danger" }, "*")
                ], -1))
              ]),
              _createElementVNode("button", {
                class: "btn black normal justify-content-center mx-0 btn-filtre",
                onClick: handleExportExcel,
                disabled: loading.value
              }, [...(_cache[19] || (_cache[19] = [
                _createElementVNode("img", {
                  src: "/public/icons/icon-excel.svg",
                  class: "btn-icon",
                  alt: ""
                }, null, -1),
                _createElementVNode("span", null, "Exporter Excel", -1)
              ]))], 8, _hoisted_17),
              _createElementVNode("button", {
                class: "btn black normal justify-content-center mx-0 btn-filtre",
                onClick: handleExportPdf,
                disabled: loading.value
              }, [...(_cache[20] || (_cache[20] = [
                _createElementVNode("img", {
                  src: "/public/icons/icon-pdf.svg",
                  class: "btn-icon",
                  alt: ""
                }, null, -1),
                _createElementVNode("span", null, "Exporter PDF", -1)
              ]))], 8, _hoisted_18)
            ])
          ], 2)
        ])
      ]),
      _createElementVNode("table", _hoisted_19, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", null, [
              _createElementVNode("label", _hoisted_20, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  name: "check-all",
                  id: "check-all",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectAll).value = $event)),
                  onChange: handleSelectAll
                }, null, 544), [
                  [_vModelCheckbox, selectAll.value]
                ])
              ])
            ]),
            _cache[27] || (_cache[27] = _createElementVNode("th", null, null, -1)),
            _cache[28] || (_cache[28] = _createElementVNode("th", null, [
              _createElementVNode("img", {
                src: "/public/icons/icon-filter-up.svg",
                class: "size-xxs mt--1",
                alt: ""
              }),
              _createTextVNode(" Transaction ")
            ], -1)),
            _cache[29] || (_cache[29] = _createElementVNode("th", null, [
              _createElementVNode("img", {
                src: "/public/icons/icon-filter-up.svg",
                class: "size-xxs mt--1",
                alt: ""
              }),
              _createTextVNode(" Montant ")
            ], -1)),
            _cache[30] || (_cache[30] = _createElementVNode("th", null, [
              _createElementVNode("img", {
                src: "/public/icons/icon-filter-up.svg",
                class: "size-xxs mt--1",
                alt: ""
              }),
              _createTextVNode(" Statut ")
            ], -1)),
            _cache[31] || (_cache[31] = _createElementVNode("th", null, [
              _createElementVNode("img", {
                src: "/public/icons/icon-filter-none.svg",
                class: "size-xxs mt--1",
                alt: ""
              }),
              _createTextVNode(" Date ")
            ], -1)),
            _createElementVNode("th", _hoisted_21, [
              _createElementVNode("button", {
                class: _normalizeClass(["btn-ultra white2 tips", { 'display-none': selectedItems.value.length === 0 }]),
                disabled: loading.value,
                onClick: doDeleteSelectedItems
              }, [
                _cache[24] || (_cache[24] = _createElementVNode("div", { class: "btn-show" }, [
                  _createElementVNode("img", {
                    src: "/public/icons/icon-delete.svg",
                    class: "btn-icon",
                    alt: ""
                  }),
                  _createElementVNode("span", null, "Supprimer")
                ], -1)),
                _createElementVNode("div", {
                  class: _normalizeClass(["btn-loading", { 'display-none': !loading.value }])
                }, [...(_cache[23] || (_cache[23] = [
                  _createElementVNode("div", { class: "loader-dots" }, null, -1)
                ]))], 2)
              ], 10, _hoisted_22),
              _createElementVNode("button", {
                class: _normalizeClass(["btn-ultra color2 tips", { 'display-none': selectedItems.value.length === 0 }]),
                disabled: loading.value,
                onClick: doToggleEtatValideSelectedItems
              }, [
                _cache[26] || (_cache[26] = _createElementVNode("div", { class: "btn-show" }, [
                  _createElementVNode("img", {
                    src: "/public/icons/icon-actif.svg",
                    class: "btn-icon",
                    alt: ""
                  }),
                  _createElementVNode("span", null, "Actif")
                ], -1)),
                _createElementVNode("div", {
                  class: _normalizeClass(["btn-loading", { 'display-none': !loading.value }])
                }, [...(_cache[25] || (_cache[25] = [
                  _createElementVNode("div", { class: "loader-dots" }, null, -1)
                ]))], 2)
              ], 10, _hoisted_23)
            ])
          ])
        ]),
        _createElementVNode("tbody", null, [
          (members.value.length === 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_24, [...(_cache[32] || (_cache[32] = [
                _createElementVNode("td", { colspan: "7" }, [
                  _createElementVNode("div", { class: "text-center text-grey-700 py-10" }, "Aucun membre trouvé")
                ], -1)
              ]))]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(members.value, (member, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: member.id || index
            }, [
              _createElementVNode("tr", {
                class: "text-grey-700 over-effect",
                onClick: ($event: any) => (goToMemberDetail(member.id)),
                style: {"cursor":"pointer"}
              }, [
                _createElementVNode("td", {
                  class: "selection-item",
                  onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _createElementVNode("label", {
                    class: "btn-circle",
                    for: 'check-' + index
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      id: 'check-' + index,
                      value: member.id,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedItems).value = $event))
                    }, null, 8, _hoisted_27), [
                      [_vModelCheckbox, selectedItems.value]
                    ])
                  ], 8, _hoisted_26)
                ]),
                _createElementVNode("td", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("img", {
                      src: member.photo_url ? member.photo_url : '/public/assets/users/300w/user2.jpg',
                      width: "100%"
                    }, null, 8, _hoisted_30)
                  ]),
                  _createElementVNode("div", {
                    class: "square-xl rounded-15 ml-3 px-3 py-3",
                    style: _normalizeStyle({ backgroundColor: getCardColor(member.actif === 1 ? 'actif' : 'inactif') })
                  }, [...(_cache[33] || (_cache[33] = [
                    _createElementVNode("img", {
                      src: "/public/icons/icon-carte.svg",
                      width: "100%"
                    }, null, -1)
                  ]))], 4)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("h5", _hoisted_31, _toDisplayString(member.nom), 1),
                  _createElementVNode("span", _hoisted_32, _toDisplayString(member.prenom), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("p", _hoisted_33, _toDisplayString(member.collectivite?.nom || member.collectivite || 'N/A'), 1)
                ]),
                _createElementVNode("td", null, [
                  _createTextVNode(_toDisplayString(member.actif === 1 ? 'Actif' : 'Inactif'), 1),
                  _cache[34] || (_cache[34] = _createElementVNode("br", null, null, -1)),
                  _createElementVNode("span", _hoisted_34, _toDisplayString(formatDate(member.created_at)), 1)
                ]),
                _createElementVNode("td", null, [
                  _cache[35] || (_cache[35] = _createTextVNode(" Dernière connexion", -1)),
                  _cache[36] || (_cache[36] = _createElementVNode("br", null, null, -1)),
                  _createElementVNode("b", _hoisted_35, _toDisplayString(formatDate(member.created_at)), 1)
                ]),
                _createElementVNode("td", _hoisted_36, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["btn-ultra white2 tips", { 'display-none': member.deleted_at === null }]),
                    disabled: loading.value,
                    onClick: _withModifiers(($event: any) => (doDeleteItem(member)), ["stop"])
                  }, [
                    _cache[38] || (_cache[38] = _createElementVNode("div", { class: "btn-show" }, [
                      _createElementVNode("img", {
                        src: "/public/icons/icon-destroy.svg",
                        class: "btn-icon icon-neutral",
                        alt: ""
                      }),
                      _createElementVNode("span", null, "Détruire")
                    ], -1)),
                    _createElementVNode("div", {
                      class: _normalizeClass(["btn-loading", { 'display-none': !loading.value }])
                    }, [...(_cache[37] || (_cache[37] = [
                      _createElementVNode("div", { class: "loader-dots" }, null, -1)
                    ]))], 2)
                  ], 10, _hoisted_37),
                  _createElementVNode("button", {
                    class: _normalizeClass(["btn-ultra white2 tips", { 'display-none': member.deleted_at !== null }]),
                    disabled: loading.value,
                    onClick: _withModifiers(($event: any) => (doDeleteItem(member)), ["stop"])
                  }, [
                    _cache[40] || (_cache[40] = _createElementVNode("div", { class: "btn-show" }, [
                      _createElementVNode("img", {
                        src: "/public/icons/icon-delete.svg",
                        class: "btn-icon",
                        alt: ""
                      }),
                      _createElementVNode("span", null, "Supprimer")
                    ], -1)),
                    _createElementVNode("div", {
                      class: _normalizeClass(["btn-loading", { 'display-none': !loading.value }])
                    }, [...(_cache[39] || (_cache[39] = [
                      _createElementVNode("div", { class: "loader-dots" }, null, -1)
                    ]))], 2)
                  ], 10, _hoisted_38),
                  _createElementVNode("button", {
                    class: _normalizeClass(["btn-ultra white2 tips", { 'display-none': member.deleted_at === null }]),
                    disabled: loading.value,
                    onClick: _withModifiers(($event: any) => (doRestoreItem(member)), ["stop"])
                  }, [
                    _cache[42] || (_cache[42] = _createElementVNode("div", { class: "btn-show" }, [
                      _createElementVNode("img", {
                        src: "/public/icons/icon-restaurer.svg",
                        class: "btn-icon icon-neutral",
                        alt: ""
                      }),
                      _createElementVNode("span", null, "Restaurer")
                    ], -1)),
                    _createElementVNode("div", {
                      class: _normalizeClass(["btn-loading", { 'display-none': !loading.value }])
                    }, [...(_cache[41] || (_cache[41] = [
                      _createElementVNode("div", { class: "loader-dots" }, null, -1)
                    ]))], 2)
                  ], 10, _hoisted_39),
                  _createElementVNode("button", {
                    class: _normalizeClass(["btn-ultra color2 tips", { 'display-none': member.deleted_at !== null || member.actif !== 1 }]),
                    disabled: loading.value,
                    onClick: _withModifiers(($event: any) => (doToggleEtatValideAction([member.id])), ["stop"])
                  }, [
                    _cache[44] || (_cache[44] = _createElementVNode("div", { class: "btn-show" }, [
                      _createElementVNode("img", {
                        src: "/public/icons/icon-actif.svg",
                        class: "btn-icon",
                        alt: ""
                      }),
                      _createElementVNode("span", null, "Actif")
                    ], -1)),
                    _createElementVNode("div", {
                      class: _normalizeClass(["btn-loading", { 'display-none': !loading.value }])
                    }, [...(_cache[43] || (_cache[43] = [
                      _createElementVNode("div", { class: "loader-dots" }, null, -1)
                    ]))], 2)
                  ], 10, _hoisted_40),
                  _createElementVNode("button", {
                    class: "btn",
                    onClick: _withModifiers(($event: any) => (goToMemberEdit(member.id)), ["stop"]),
                    disabled: loading.value
                  }, [...(_cache[45] || (_cache[45] = [
                    _createElementVNode("img", {
                      src: "/public/icons/icon-edit.svg",
                      class: "btn-icon",
                      alt: ""
                    }, null, -1),
                    _createElementVNode("span", null, "Editer", -1)
                  ]))], 8, _hoisted_41),
                  _createElementVNode("button", {
                    class: "btn white2 collapse-open-table",
                    onClick: _withModifiers(($event: any) => (toggleRowDetails(index)), ["stop"])
                  }, [...(_cache[46] || (_cache[46] = [
                    _createElementVNode("img", {
                      src: "/public/icons/icon-list.svg",
                      class: "btn-icon",
                      alt: ""
                    }, null, -1),
                    _createElementVNode("span", null, "Plus", -1)
                  ]))], 8, _hoisted_42)
                ])
              ], 8, _hoisted_25),
              (expandedRows.value.includes(index))
                ? (_openBlock(), _createElementBlock("tr", _hoisted_43, [
                    _createElementVNode("td", _hoisted_44, [
                      _createElementVNode("div", _hoisted_45, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((member.permissions || []), (permission, pIndex) => {
                          return (_openBlock(), _createElementBlock("p", {
                            class: "flex text-grey-600",
                            key: pIndex
                          }, [
                            _cache[47] || (_cache[47] = _createElementVNode("img", {
                              src: "/public/icons/icon-securite-permission.svg",
                              class: "size-xs icon-grey mr-2",
                              alt: ""
                            }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(permission), 1)
                          ]))
                        }), 128)),
                        (!member.permissions || member.permissions.length === 0)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_46, " Aucune permission spécifiée "))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ])
      ])
    ]),
    _cache[52] || (_cache[52] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    _createElementVNode("div", _hoisted_47, [
      _createElementVNode("button", {
        class: _normalizeClass(["page-link", { active: currentPage.value === 1 }]),
        onClick: _cache[7] || (_cache[7] = ($event: any) => (goToPage(currentPage.value - 1))),
        disabled: currentPage.value === 1
      }, [...(_cache[48] || (_cache[48] = [
        _createElementVNode("img", {
          src: "/public/icons/icon-pagination-prev.svg",
          class: "pagination-icon",
          alt: ""
        }, null, -1),
        _createTextVNode(" Précedent ", -1)
      ]))], 10, _hoisted_48),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visiblePages.value, (page) => {
        return (_openBlock(), _createElementBlock("button", {
          key: page,
          class: _normalizeClass(["page-link", { active: currentPage.value === page }]),
          onClick: ($event: any) => (goToPage(page))
        }, _toDisplayString(page), 11, _hoisted_49))
      }), 128)),
      _createElementVNode("button", {
        class: "page-link pl-4",
        onClick: _cache[8] || (_cache[8] = ($event: any) => (goToPage(currentPage.value + 1))),
        disabled: currentPage.value === totalPages.value
      }, [...(_cache[49] || (_cache[49] = [
        _createTextVNode(" Suivant ", -1),
        _createElementVNode("img", {
          src: "/public/icons/icon-pagination-next.svg",
          class: "pagination-icon ml-2",
          alt: ""
        }, null, -1)
      ]))], 8, _hoisted_50)
    ]),
    _cache[53] || (_cache[53] = _createElementVNode("div", { class: "clear-both h-70" }, null, -1))
  ]))
}
}

})